import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
// Ensure Shopify is configured globally on app startup
import '@/config/shopifyConfig'
// Initialize Google Analytics
import { initializeGA } from '@/lib/analytics'
// LCP image (chain) – preload so the browser discovers it from the initial HTML
import ketteImg from '@/assets/kette-coming-soon.png'

const preloadLink = document.createElement('link')
preloadLink.rel = 'preload'
preloadLink.as = 'image'
preloadLink.href = ketteImg
preloadLink.fetchPriority = 'high'
document.head.appendChild(preloadLink)

// Initialize Google Analytics
initializeGA();

createRoot(document.getElementById("root")!).render(<App />);
